export default [
    {
        name: 'Unit',
        value: 's_unit'
    },
    {
        name: 'Status',
        value: 's_status'
    },
    {
        name: 'Address',
        value: 's_address'
    },
    {
        name: 'Phone',
        value: 's_phone'
    },
    {
        name: 'Firms Code',
        value: 's_firms_code'
    },
    {
        name: 'Weekday Hours',
        value: 's_weekday_hours'
    },
    {
        name: 'Weekend Hours',
        value: 's_weekend_hours'
    },
    {
        name: 'Airport',
        value: 's_airport'
    },
    {
        name: 'Airport Code',
        value: 's_airport_code'
    },
    {
        name: 'Import ISC',
        value: 'f_import_isc_cost'
    },
    {
        name: 'Import PER KG',
        value: 'f_import_per_kg'
    },
    {
        name: 'Import Min Charge',
        value: 'f_import_min_charge'
    },
    {
        name: 'Add 1st Free Day',
        value: 'i_add_first_free_day'
    },
    {
        name: 'Add 2nd Free Day',
        value: 'i_add_second_free_day'
    }
]